import { render, staticRenderFns } from "./CreateUOM.vue?vue&type=template&id=56a0d817&scoped=true"
import script from "./CreateUOM.vue?vue&type=script&lang=js"
export * from "./CreateUOM.vue?vue&type=script&lang=js"
import style0 from "./CreateUOM.vue?vue&type=style&index=0&id=56a0d817&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a0d817",
  null
  
)

export default component.exports